import React from 'react';
import { Link } from 'react-router-dom';

const ProcurementMenu = ({
    activeMenu = ''
}) => {
    return (
        <div className="inner-menu-container bg-white shadow-sm">
            <div className="container-fluid px-lg-5">
                <ul className="nav secondary-menu mw-100 flex-nowrap gap-xl-5 flex-fill fs-sm fw-semibold text-center border-0 text-nowrap overflow-auto">
                    <li className="nav-item flex-fill">
                        <Link to="/quotation/list" className={`d-block text-black px-2 px-sm-3 py-3 py-sm-4 position-relative ${activeMenu === 'quotations' ? 'active' : ''}`}>
                            Quotations
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link to="/procurement/invoice/list" className={`d-block text-black px-2 px-sm-3 py-3 py-sm-4 position-relative ${activeMenu === 'procurements' ? 'active' : ''}`}>
                            Procurement
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link to="/supplier-approval" className={`d-block text-black px-2 px-sm-3 py-3 py-sm-4 position-relative ${activeMenu === 'supplier-approval' ? 'active' : ''}`}>
                            Supplier Approval
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link to="/purchase-needs" className={`d-block text-black px-2 px-sm-3 py-3 py-sm-4 position-relative ${activeMenu === 'purchase-needs' ? 'active' : ''}`}>
                            Purchase Needs
                        </Link>
                    </li>
                   
                </ul>
            </div>
        </div>
    );
};

export default ProcurementMenu;
